var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110,
    height: 54,
    viewBox: "0 0 110 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2",
    "data-name": "Rect\\xE1ngulo 2",
    width: 110,
    height: 54,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    "data-name": "Trazado 44",
    d: "M25.486,27.436a2.478,2.478,0,0,1-.97-.2L10.108,21.151l-6.791,2.5a2.457,2.457,0,1,1-1.7-4.609L9.333,16.2a2.451,2.451,0,0,1,1.836.054l14.377,6.079L46.6,14.442a2.457,2.457,0,1,1,1.735,4.6l-21.982,8.24a2.5,2.5,0,0,1-.869.157",
    fill: "#fdb54e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M48.233,12.191a2.455,2.455,0,0,1-.857-4.759l8.4-3.1a2.424,2.424,0,0,1,1.405-.091L67.688,6.635c1.071-.414,2.2-.869,3.364-1.341C76.558,3.071,82.789.553,88.29.274,95.108-1.007,100,2.54,100.925,3.921a2.461,2.461,0,0,1-3.94,2.939,9.482,9.482,0,0,0-7.918-1.734,2.385,2.385,0,0,1-.38.046c-4.7.2-10.586,2.574-15.782,4.674-1.458.589-2.859,1.155-4.166,1.647a2.465,2.465,0,0,1-1.42.1L56.8,9.191,49.09,12.037a2.469,2.469,0,0,1-.857.155",
    fill: "#fdb54e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46",
    "data-name": "Trazado 46",
    d: "M109.991,14.6c-.271-1.213-.406-3.1-5.958-3.509a14.244,14.244,0,0,0-3.113.274A11.584,11.584,0,0,0,90.626,8.8c-6.5.27-14.622,4.185-20.716,6.476L58.672,12.712l-8.4,3.1L55.829,20.4h.135L27.529,31.059l-6.636-2.831L17.509,26.88l-5.281-2.3L4.508,27.42l.679.944L11.008,34.3l.677.674-2.3,4.858,4.2-1.483.812-.809.543.674,3.519,3.511,6.771,6.88h.136c.136.134.406.134.811.269,2.3.4,7.583-.4,14.219-2.7a.492.492,0,0,1-.409-.14,4.118,4.118,0,0,1-1.623-1.752,9.4,9.4,0,0,1-.406-1.079,4.7,4.7,0,0,1-.27-3.509.291.291,0,0,1,.27-.27,1.025,1.025,0,0,1,.542.135,5.08,5.08,0,0,1,1.9,2.7,9.088,9.088,0,0,0,.405,1.079v.135c.947-.405,1.625-.674,1.9-.809l11.238-4.183L44.724,54l11.105-4.183,19.09-19.162,19.229-7.149,2.437-.944c.136,0,.136,0,.271-.134a59.857,59.857,0,0,0,6.5-2.836c7.174-2.831,6.633-4.993,6.633-4.993",
    fill: "#20221d",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlane);
export default __webpack_public_path__ + "static/media/iconPlane.6e88bd573c553d909e5b951cfbdf124a.svg";
export { ForwardRef as ReactComponent };